import { createModule } from "redux-mvc";

import model from "./model";

import searchBarModule from "ui-kit/SearchBar";
import sagasModule from "./sagas";

import sessionModalModule from "EventLight/Sessions/AddSessionModal";

import filesModule from "Portal/NewPortal/Sections/Sessions/FlyOver/View/Files";

const module = createModule({
  ...model,
  observedDomains: ["user", "portal", "permissions", "organization"]
});
module.plugModule(searchBarModule);
module.plugModule(sessionModalModule);
module.plugModule(filesModule);
module.setRootSaga(sagasModule);

export default module;
